import useManageRPPermissions from '../utils/useManageRPPermissions';
import { SelectorList } from 'components';

export default function RPHouseList({
	selectorListState,
	homesBasePath = '/homes',
}) {
	const linkTo = `${homesBasePath}/manage/`;
	const permissions = useManageRPPermissions();
	const disable = permissions.house !== 'edit';

	if (permissions.house === 'view') {
		const house = selectorListState?.assignedList?.[0];
		if (!house) return null;
	}

	return (
		<SelectorList
			label='HOUSEHOLD'
			textFieldLabel='Household (required)'
			linkTo={linkTo}
			sort='name'
			fromList='house'
			{...selectorListState}
			disable={disable}
			disableRemove={true}
			required={true}
		/>
	);
}
